import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import List from 'components/Common/List'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import LineArrowsRightDownIcon from 'components/Luxkit/Icons/line/LineArrowsRightDownIcon'

const AboutRoomContainer = styled(Group)`
  padding: ${rem(20)};
`

interface Props {
  pkg: App.Package;
}

function AlwaysOnAboutRoomModalTab(props: Props) {
  const { pkg } = props

  const amenities = pkg.roomType?.amenities
  const policyDescription = pkg.roomPolicyDescription

  return (
    <AboutRoomContainer direction="vertical" gap={32}>
      <BodyText variant="medium">{pkg.roomType?.description}</BodyText>
      <Group direction="vertical" gap={12}>
        <Heading variant="heading4">Room Options</Heading>
        <BodyTextBlock variant="medium" startIcon={<LineArrowsRightDownIcon />}>
          {pkg.roomType?.sizeSqm} m&sup2;
        </BodyTextBlock>
      </Group>
      {!!amenities?.length && <Group direction="vertical" gap={12}>
        <Heading variant="heading4">Room Amenities</Heading>
        <List>
          {amenities.map(amenity => <BodyText
            key={amenity.description}
            as="li"
            variant="medium"
          >
            {amenity.description}
          </BodyText>)}
        </List>
      </Group>}
      {policyDescription && <Group direction="vertical" gap={12}>
        <Heading variant="heading4">Room Policies</Heading>
        <MarkdownRender fontSize="medium" content={policyDescription} type="compact" />
      </Group>}
    </AboutRoomContainer>
  )
}

export default AlwaysOnAboutRoomModalTab
